import { render } from "./Res.vue?vue&type=template&id=6956703e"
import script from "./Res.vue?vue&type=script&lang=js"
export * from "./Res.vue?vue&type=script&lang=js"

import "./Res.vue?vue&type=style&index=0&id=6956703e&lang=scss"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__